export async function importModule() {
  return await import(/* webpackChunkName: "croppie" */ 'croppie');
}